import { actAuditCertificationListFetch } from 'actions/auditCertificationActions';
import { actBibleListFetch } from 'actions/bibleActions';
import { actProductCategoryListFetch } from 'actions/productCategoryActions';
import { actTagsFetch } from 'actions/tagsActions';
import {
  ApiV1Base, 
  ApiPrefix,
  statusCheck,
  getCookie,
  json,
  checkToGetErrorResponse,
  setCookie,
} from 'util/icwUtility';
import fetch from 'cross-fetch';
import { actAuthenticateUser, actUserProfileFetch } from 'actions/loginStateActions';
import { getLSItem, setLSItem, removeLSItem } from 'util/localStorageProvider';
import { LOCKED_LOGIN_TIME } from 'shared/constants';
import { LOGIN_INIT, LOGIN_BEGIN, LOGIN_SUCCESS, LOGIN_FAIL, LoginTypes } from './types';

export function actLoginInit() {
  return { type: LOGIN_INIT };
}

export function actLoginBegin() {
  return { type: LOGIN_BEGIN };
}

export function actLoginSuccess() {
  return { type: LOGIN_SUCCESS };
}

export function actLoginFail(error) {
  return { type: LOGIN_FAIL, payload: error };
}
export function unLocked() {
  return { type: LOGIN_FAIL, payload: { locked: false } };
}

export function actLogin(email, password, status, isAli) {
  return (dispatch) => {
    dispatch(actLoginBegin());
    return dispatch(actAuthenticateUser(email, password, isAli))
      .then(() =>
        Promise.all([
          dispatch(actUserProfileFetch(status)),
          dispatch(actAuditCertificationListFetch()),
          dispatch(actBibleListFetch()),
          dispatch(actProductCategoryListFetch()),
          dispatch(actTagsFetch()),
        ])
      )
      .then(([userData]) => {
        removeLSItem('lockedLogin');
        removeLSItem('lockedLoginTime');
        dispatch(actLoginSuccess());
        // dispatch(actWechatLogin(userData));
      })
      .catch((err) => {
        Promise.resolve(err.text()).then((errString) => {
          if (errString.includes('{')) {
            const errorObj = JSON.parse(errString);
            dispatch(actLoginFail(errorObj));
            const lockedStorage = getLSItem('lockedLogin');
            const lockedTimeStorage = parseInt(getLSItem('lockedLoginTime') || 0, 10);
            const nowTime = new Date().getTime();
            if (
              (errorObj.locked && lockedStorage !== 'true') ||
              lockedTimeStorage - nowTime > LOCKED_LOGIN_TIME
            ) {
              setLSItem('lockedLogin', 'true');
              setLSItem('lockedLoginTime', new Date().getTime());
            }
          } else {
            dispatch(actLoginFail(true));
          }
        });
      });
  };
}

// USER_UPDATE_PASSWORD
export function userUpdatePasswordLoading() {
  return { type: LoginTypes.USER_UPDATE_PASSWORD.LOADING };
}
export function userUpdatePasswordSuccess(data) {
  return { type: LoginTypes.USER_UPDATE_PASSWORD.SUCCESS, payload: data };
}
export function userUpdatePasswordError(error) {
  return { type: LoginTypes.USER_UPDATE_PASSWORD.ERROR, payload: error };
}
export function userUpdatePassword(data, cb) {
  return (dispatch) => {
    dispatch(userUpdatePasswordLoading());
    return (
      fetch(`${ApiV1Base}${ApiPrefix}/user/password`, {
        method: 'POST',
        headers: {
          Authorization: getCookie('token'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(statusCheck)
        // .then(json)
        .then((res) => {
          dispatch(userUpdatePasswordSuccess(res));
          if (cb) cb();
        })
        .catch((err) => {
          dispatch(userUpdatePasswordError(typeof err === 'object' ? err.message : err));
        })
    );
  };
}

// USER_SOCIAL_LOGIN
export function userSocialLoginLoading() {
  return { type: LoginTypes.USER_SOCIAL_LOGIN.LOADING };
}
export function userSocialLoginSuccess(data, cb) {
  if (cb) cb(data);
  return { type: LoginTypes.USER_SOCIAL_LOGIN.SUCCESS, payload: data };
}
export function userSocialLoginError(error) {
  return { type: LoginTypes.USER_SOCIAL_LOGIN.ERROR, payload: error };
}
export function userSocialLogin(data, cb) {
  return (dispatch) => {
    dispatch(userSocialLoginLoading());
    return fetch(`${ApiV1Base}${ApiPrefix}/auth/socialLogin`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(checkToGetErrorResponse)
      .then(json)
      .then((res) => {
        const { token, isActivated = true } = res; // activated by default
        if (token) {
          setCookie('token', token);
          setCookie('activated_user', isActivated);
          dispatch(userSocialLoginSuccess(res, cb));
        }
      })
      .then(() =>
        Promise.all([
          dispatch(actUserProfileFetch()),
          dispatch(actAuditCertificationListFetch()),
          dispatch(actBibleListFetch()),
          dispatch(actProductCategoryListFetch()),
          dispatch(actTagsFetch()),
        ])
      )
      .then(([userData]) => {
        removeLSItem('lockedLogin');
        removeLSItem('lockedLoginTime');
        // dispatch(actWechatLogin(userData));
      })
      .catch((err) => {
        Promise.resolve(err.text()).then((errString) => {
          if (errString.includes('{')) {
            const errorObj = JSON.parse(errString);
            dispatch(actLoginFail(errorObj));
            const lockedStorage = getLSItem('lockedLogin');
            const lockedTimeStorage = parseInt(getLSItem('lockedLoginTime') || 0, 10);
            const nowTime = new Date().getTime();
            if (
              (errorObj.locked && lockedStorage !== 'true') ||
              lockedTimeStorage - nowTime > LOCKED_LOGIN_TIME
            ) {
              setLSItem('lockedLogin', 'true');
              setLSItem('lockedLoginTime', new Date().getTime());
            }
          } else {
            dispatch(userSocialLoginError(typeof err === 'object' ? err.message : err));
          }
        });
      });
  };
}

// USER_GET_LINKEDIN_INFO
export function userGetLinkedinInfoLoading() {
  return { type: LoginTypes.USER_GET_LINKEDIN_INFO.LOADING };
}
export function userGetLinkedinInfoSuccess(data, cb) {
  if (cb) cb(data);
  return { type: LoginTypes.USER_GET_LINKEDIN_INFO.SUCCESS, payload: data };
}
export function userGetLinkedinInfoError(error) {
  return { type: LoginTypes.USER_GET_LINKEDIN_INFO.ERROR, payload: error };
}
export function userGetLinkedinInfo(data, cb) {
  return (dispatch) => {
    dispatch(userGetLinkedinInfoLoading());
    return fetch(`${ApiV1Base}${ApiPrefix}/auth/linkedin`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(checkToGetErrorResponse)
      .then(json)
      .then((res) => {
        dispatch(userGetLinkedinInfoSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(userGetLinkedinInfoError(typeof err === 'object' ? err.message : err));
      });
  };
}
